import {Component, OnInit} from '@angular/core';
import {CountryChartData} from '../../../../models/country-chart-data.interface';
import {Master} from '../../../../../admin/models/master.interface';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';
import {Countries} from '../../../../../admin/models/countries.interface';
import {DownloadDataService} from '../../../../../core/services/download-data.service';

@Component({
  selector: 'app-european-trend-chart',
  templateUrl: './european-trend-chart.component.html',
  styleUrls: ['./european-trend-chart.component.scss']
})
export class EuropeanTrendChartComponent implements OnInit {

  text = 'Trend in put on market reported - Europe';
  subtitle = '';
  data!: CountryChartData[];
  displayUnits = 'ABSOLUTE';
  years!: number[];
  countries!: Countries[];
  categories!: Master[];
  countryCategory!: string;
  dataCountries!: string[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly downloadDataService: DownloadDataService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.downloadDataService.getAllCountries().subscribe(data => this.countries = data);
    if (this.router.url.includes('putonmarket')) {
      this.countryCategory = 'putonmarket';
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    if (this.router.url.includes('collected')) {
      this.text = 'Trend in collected reported - Europe';
      this.countryCategory = 'collected';
      this.kfChartsService.getCollectionStreams().subscribe(data => this.categories = data);
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', search.categoryType ? search.categoryType : 'NEW')
        .subscribe(data => {
          this.years = data;
          if (!search.startYear) {
            search.startYear = data[2];
          }
          this.subtitle = (search.startYear) + ' - ' + (data[0]) + (search.displayUnits === 'SPECIFIC' ? ' (kg/inh)' : ' (tons)');
          if (!search.categoryType) {
            search.categoryType = 'NEW';
          }
          if (!search.displayUnits) {
            search.displayUnits = 'ABSOLUTE';
          }
          this.kfChartsService.getEuropeanTrend(search, this.countryCategory)
            .subscribe(response => {
            this.data = response;
            this.displayUnits = search.displayUnits || 'ABSOLUTE';
            this.kfChartsService.getEuropeanTrendCountries(
              search, this.countryCategory).subscribe(response2 => this.dataCountries = response2);
          });
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
  }

  loadCategories(event: string): void {
    if (event === 'OLD') {
      this.kfChartsService.getOldPomCategories().subscribe(data => this.categories = data);
    } else {
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', event)
      .subscribe(data => this.years = data);
  }

}
